module.exports = {
    customer: 'flyingtiger',
    assets: { logo: 'logo.svg' }
    
};